import DepositBankSettings from "@/models/Products/ProductSettings/DefaultSettings/Banking/DepositBankSettings";

export default class UpdateDepositBankSettingsRequest extends DepositBankSettings {
    updatedAt: Date;
    public constructor(settings: DepositBankSettings, updatedAt: Date) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
            this.bacsInboundEnabled = settings.bacsInboundEnabled;
            this.bacsOutboundEnabled = settings.bacsOutboundEnabled;
            this.chapsInboundEnabled = settings.chapsInboundEnabled;
            this.chapsOutboundEnabled = settings.chapsOutboundEnabled;
            this.directCreditsEnabled = settings.directCreditsEnabled;
            this.directDebitsEnabled = settings.directDebitsEnabled;
            this.fasterPaymentsInboundEnabled = settings.fasterPaymentsInboundEnabled;
            this.fasterPaymentsOutboundEnabled = settings.fasterPaymentsOutboundEnabled;
        }
    }
}